import FilterComponentConstructor from './filterComponentConstructor';

export default FilterComponentConstructor;
